<template>
  <div>
    <div class="top_bar base-clear">
      <div class="logo">
        <span class="logo-title">{{logoTitle}}</span>
        <img :src="require('../../assets/images/logo/logo.png')" alt="">
      </div>
      <marquee
        id="noticeLink"
        scrollamount="2"
        class="marquee"
        @click="changeRoute('公告')"
      >{{message}}</marquee>
      <div class="user_info_wrap base-clear">
        <div class="user_pic"></div>
        <div class="user_info">
          <p class="user_name">
            <span id="userName">{{userName}}</span>
            <span id="state"></span>
            <span id="skinChange" version="1.1.22">
              <a class="skin_btn" href="javascript:;">换肤</a>
              <em id="skinBox" class>
                <a
                  data-skin="Yellow"
                  class="user_skin skin_yellow"
                  href="javascript:;"
                  @click="changSkin('Yellow')"
                >
                  <i></i>栀子黄
                </a>
                <a
                  data-skin="Blue"
                  class="user_skin skin_blue"
                  href="javascript:;"
                  @click="changSkin('Blue')"
                >
                  <i></i>天空蓝
                </a>
                <a
                  data-skin="Violet"
                  class="user_skin skin_red"
                  href="javascript:;"
                  @click="changSkin('Violet')"
                >
                  <i></i>宝石红
                </a>
                <a
                  data-skin="Green"
                  class="user_skin skin_green"
                  href="javascript:;"
                  @click="changSkin('Green')"
                >
                  <i></i>翡翠绿
                </a>
              </em>
            </span>
            <b id="soundSwitch" title="聲音開關" class="lbOn"></b>
          </p>
          <p id="ppurl">
            <span class="nameType"></span>额度：
            <span id="creditSpan">{{ed}}</span>
            <em>|</em>
            <span class="nameType"></span>可用：
            <span id="usableCreditSpan">{{ky}}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="top_menu base-clear">
      <div class="menu" style="z-index: 10;">
        <a id="menuText" href="javascript:void(0)" data-index="3">
          <span>{{current_select.gameName}}</span>
          <i></i>
        </a>
        <div style="display: none;" class="menuList">
          <ul id="menuList">
            <li v-for="(item,index) in menuList" :key="index">
              <a href="javascript:void(0)" @click="changeGame(item)">{{item.gameName}}</a>
            </li>
          </ul>
        </div>
      </div>
      <div id="navText" class="nav base-clear">
        <a
          style="cursor: pointer;"
          v-for="(item,index) in navList"
          :key="item[index]"
          @click="changeRoute(item.title)"
          class="navBtn"
        >
          <i :class="item.className"></i>
          <span>{{item.title}}</span>
        </a>
      </div>
    </div>

    <div id="mainIframe" style="position:relative;padding-left:220px; width: calc(100% - 220px);z-index: 1;">
      <div class="member-info" style="position: absolute; left: 0; top:0; width: 220px; padding: 0 10px;">
        <div style="width:200px">
          <table style="width: 100%;border-radius: none; border">
            <thead style="width: 100%;">
              <th id="my_bet" colspan="2" style="color: rgb(255, 255, 255); font-weight: bold; padding: 6px 0;  text-align: center;border-radius: 0;">
                会员信息
              </th>
            </thead>
            <tbody style="">
              <tr>
                <td  style="padding: 2px 4px;  height: 22px; text-align: center;">
                  会员
                </td>
                <td colspan="2" style="padding: 2px 4px;  height: 22px; text-align: center;" >{{userName}}</td>
              </tr>
              <tr>
                <td style="padding: 2px 4px;  height: 22px; text-align: center;" >
                  信用额度
                </td>
                <td colspan="2" style="padding: 2px 4px;  height: 22px; text-align: center;">{{ed}}</td>
              </tr>
              <tr>
                <td style="padding: 2px 4px;  height: 22px; text-align: center;">
                  可用额度
                </td>
                <td style="padding: 2px 4px;  height: 22px; text-align: center;" colspan="2">
                  {{ky}}
                  <img @click="refreshInfo()" src="../../assets/images/refresh.png" style="margin-left:5px;margin-bottom:-2px;width:15px;height:15px;cursor: pointer;" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>


      <div class="top_info">
        <div class="top_info_box base-clear">
          <div class="game_name_wrap base-clear">
            <div class="game_pic">
              <a href target="_blank">
                <img id="game_logo" src="../../assets/images/SSC.png" alt />
              </a>
            </div>
            <div class="game_name" id="game_name">
              <h5>
                <span id="game_big_name">{{gameName}}</span>
              </h5>
              <p name="row_small">{{gameTips}}</p>
              <p>
                今天已售
                <b id="phase1" class="green">{{ys}}</b> 期，还剩
                <b id="phase2" class="green">{{sy}}</b> 期
              </p>
            </div>
          </div>
          <div class="game_info_wrap">
            <h4>
              <b class="red">
                今日输贏：
                <i id="profit">{{result}}</i>
              </b>&nbsp;&nbsp;&nbsp;第
              <span id="NowJq">{{qh}}</span>期，
              距离<label id="closeText">{{fengpan}}</label>：
              <label id="closedTime" class="time">
                <span class="sm">0</span>
                <span class="m">0</span>分
                <span class="ss">0</span>
                <span class="ms">0</span>秒
              </label>
            </h4>
            <h5>
              第
              <b id="newPhase">{{syq}}</b>期开奖：
              <strong id="prevBall" style="margin-top: -10px;" class="ball">
                <i :class="'SSCNo_'+item.num" v-for="(item,index) in boorList" :key="index"></i>
              </strong>
              <strong>
                <span id="fan" class="red" style="font-size: 16px;font-weight: bolder;">{{dxds}}</span>
              </strong>
              <a
                class="webbtn"
                target="view_window"
                style="margin-left: 5px;height: 15px;width: 60px; cursor: pointer;"
                :href="website"
              >开奖官网</a>
            </h5>
          </div>
          <div class="game_tool">
            <p>
              <span id="updateTime"></span>
            </p>
          </div>
        </div>
      </div>

      <!--wrap start-->

      <!--wrap end-->
    </div>
  </div>
</template>

<script>
import { showChangeSky, soundSwitch } from "../../assets/js/base";
import getData from "../getData/getData";
export default {
  name: "",
  data() {
    return {
      logoTitle: sessionStorage.getItem('title'),
      timer: null,
      parTimmer: null,
      fengpan: "封盘",
      message: "",
      userName: "",
      token: "",
      uid: 0,
      ed: 0,
      ky: 0,
      ys: 33,
      sy: 44,
      dxds:'',
      result: 0.00,
      defaultSky: "",
      qh: 0,
      syq: 0,
      jf: "",
      website: "#",
      gameName: "",
      sessionStorage: "",
      gameTips: "5分钟一期，每天00:00-24:00銷售",
      navList: [
        { className: "icon3", title: "下注明细" },
        { className: "icon4", title: "期期报表" },
        { className: "icon4", title: "结算报表" },
        { className: "icon1", title: "信用资料" },
        { className: "icon8", title: "会员日志" },
        { className: "icon5", title: "修改密码" },
        { className: "icon5", title: "历史开奖" },
        { className: "icon6", title: "玩法规则" },
        { className: "icon9", title: "线路切换" },
        { className: "icon8", title: "安全退出" }
      ],
      boorList: [],
      menuList: [],
      current_select:{'gameName':'','code':''}
    };
  },
  mounted() {
    const _this = this;
    showChangeSky();
    this.token = window.sessionStorage.getItem("login").split("&")[0];
    this.uid = window.sessionStorage.getItem("login").split("&")[1];
    this.sessionStorage = window.sessionStorage.getItem("login");
    let data = {};
    data.access_token = this.token;
    data.uid = this.uid;
    console.log(data)
    getData.postAxiosMethod("userinfo", data, res => {
      _this.userName = res.data.data.username;
      _this.ky = (res.data.data.balance * 1).toFixed(2);
      _this.ed = (res.data.data.credits * 1).toFixed(2);
      _this.defaultSky = res.data.data.skin;
      sessionStorage.setItem('Voice', res.data.data.isplayer)
      if(res.data.data.isplayer){
        $("#soundSwitch").removeClass('lbOff').addClass('lbOn')
      }else{
        $("#soundSwitch").removeClass('lbOn').addClass('lbOff')
      }
      if (res.data.data.skin == 0) {
        _this.changSkin("Yellow");
      } else if (res.data.data.skin == 2) {
        _this.changSkin("Violet");
      } else if (res.data.data.skin == 1) {
        _this.changSkin("Blue");
      } else {
        _this.changSkin("Green");
      }
    });

    this.$event.$on('topNotice', (message) => {
      this.message = message && message.content ? message.content : ""
    })
    // getData.postAxiosMethod("notice", data, res => {
    //   _this.message = res.data.data[0].content;
    // });
    this.getGameData(data);
    this.$event.$on('updateUserInfo', () =>{
      this.getUserInfo()
    })
    // this.timmer()
    //声音开关
    $("#soundSwitch")
      .unbind("click")
      .click(function() {
        var myClass = $(this).attr("class");

        $(this).removeClass();
        if (myClass == "lbOn") {
          $(this).addClass("lbOff");
          let data = {};
          data.access_token = window.sessionStorage
            .getItem("login")
            .split("&")[0];
          data.uid = window.sessionStorage.getItem("login").split("&")[1];
          data.isplayer = 0;
          getData.postAxiosMethod("audioswitch", data, res => {
            console.log(res);
            sessionStorage.setItem('Voice', data.isplayer)
          });
        } else {
          $(this).addClass("lbOn");
          let data = {};
          data.access_token = window.sessionStorage
            .getItem("login")
            .split("&")[0];
          data.uid = window.sessionStorage.getItem("login").split("&")[1];
          data.isplayer = 1;
          getData.postAxiosMethod("audioswitch", data, res => {
            console.log(res);
            sessionStorage.setItem('Voice', data.isplayer)
          });
        }

      });
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.parTimmer);
  },
  computed: {
    hj(){
      let count = 0
      this.boorList.forEach(item => {
        count += (item.num * 1)
      })
      return `${count},${count >= 23 ? '大' : '小'},${count % 2 == 0 ? '双' : '单'}`
    }
  },
  methods: {
    refreshInfo(){
      this.$loading_show()
      this.getUserInfo()
      setTimeout(() => {
        this.$loading_hide()
      }, 500);
    },
    getUserInfo(){
      let _this = this
      let data = {};
      data.access_token = this.token;
      data.uid = this.uid;
      getData.postAxiosMethod("userinfo", data, res => {
        _this.userName = res.data.data.username;
        _this.ky = (res.data.data.balance * 1).toFixed(2);
      _this.ed = (res.data.data.credits * 1).toFixed(2);
        _this.defaultSky = res.data.data.skin;
        _this.result = res.data.data.winorlose || '0.00'
        sessionStorage.setItem('Voice', res.data.data.isplayer)
        if (res.data.data.skin == 0) {
          _this.setSkin("Yellow");
        } else if (res.data.data.skin == 2) {
          _this.setSkin("Violet");
        } else if (res.data.data.skin == 1) {
          _this.setSkin("Blue");
        } else {
          _this.setSkin("Green");
        }
      });
    },
    setSkin(key){
      let skinNo = 0;
      if (key == "Yellow") {
        skinNo = 0;
        document.getElementsByTagName("body")[0].className = "Yellow";
      } else if (key == "Violet") {
        skinNo = 2;
        document.getElementsByTagName("body")[0].className = "Violet";
      } else if (key == "Blue") {
        skinNo = 1;
        document.getElementsByTagName("body")[0].className = "Blue";
      } else {
        skinNo = 3;
        document.getElementsByTagName("body")[0].className = "Green";
      }
    },
    changSkin(key) {
      let skinNo = 0;
      if (key == "Yellow") {
        skinNo = 0;
        document.getElementsByTagName("body")[0].className = "Yellow";
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.skinNo = skinNo;
        getData.postAxiosMethod("setskin", data, res => {
          console.log(res);
        });
      } else if (key == "Violet") {
        skinNo = 2;
        document.getElementsByTagName("body")[0].className = "Violet";
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.skinNo = skinNo;
        getData.postAxiosMethod("setskin", data, res => {
          //          console.log(res);
        });
      } else if (key == "Blue") {
        skinNo = 1;
        document.getElementsByTagName("body")[0].className = "Blue";
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.skinNo = skinNo;
        getData.postAxiosMethod("setskin", data, res => {});
      } else {
        skinNo = 3;
        document.getElementsByTagName("body")[0].className = "Green";
        let data = {};
        data.access_token = window.sessionStorage
          .getItem("login")
          .split("&")[0];
        data.uid = window.sessionStorage.getItem("login").split("&")[1];
        data.skinNo = skinNo;
        getData.postAxiosMethod("setskin", data, res => {});
      }
    },
    changeRoute(data) {
      this.$emit("changeRoute", data);
    },
    updateGameNav(gameInfo) {
      const nav = gameInfo && Array.isArray(gameInfo.nav) ? gameInfo.nav : null;
      if (nav) {
        window.sessionStorage.setItem("gameNav", JSON.stringify(nav));
        this.$event.$emit("updateGameNav", nav);
      } else {
        window.sessionStorage.removeItem("gameNav");
        this.$event.$emit("updateGameNav", null);
      }
    },
    updateGameNumber(gameInfo) {
      const number = gameInfo && Array.isArray(gameInfo.number) ? gameInfo.number : null;
      if (number) {
        window.sessionStorage.setItem("gameNumber", JSON.stringify(number));
      }
    },
    normalizeGameInfo(data) {
      return Array.isArray(data) ? data[0] : data;
    },
    toTwoDigits(value) {
      return value > 9 ? String(value) : "0" + value;
    },
    renderDjs(remainingSeconds) {
      const hours = Math.floor(remainingSeconds / 3600);
      const minutes = hours > 1 ? Math.floor((remainingSeconds % 3600) / 60) : Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;
      const hourHtml = hours > 1 ? String(hours).split("").map(item => `<span class="h">${item}</span>`).join("") + "时" : "";
      const minuteText = this.toTwoDigits(minutes).slice(-2);
      const secondText = this.toTwoDigits(seconds);
      $("#closedTime").removeClass("time_loading");
      document.getElementById(
        "closedTime"
      ).innerHTML = `${hourHtml}<span class="sm">${minuteText.slice(0, 1)}</span><span class="m">${minuteText.slice(1, 2)}</span>分<span class="ss">${secondText.slice(0, 1)}</span><span class="ms">${secondText.slice(1, 2)}</span>秒`;
    },
    showDjsLoading() {
      clearInterval(this.timer);
      $("#closedTime").html("").addClass("time_loading");
    },
    startDjs(time) {
      clearInterval(this.timer);
      let remainingSeconds = parseInt(time, 10);
      if (!remainingSeconds || remainingSeconds < 0) {
        this.showDjsLoading();
        return;
      }
      this.renderDjs(remainingSeconds);
      this.timer = setInterval(() => {
        remainingSeconds -= 1;
        if (remainingSeconds <= 0) {
          this.showDjsLoading();
          if (this.current_select && this.current_select.code) {
            this.getGameDataInterval(this.getGameInfoPostData(this.current_select.code));
          } else {
            this.getGameData({});
          }
          this.$event.$emit("timeOut");
          return;
        }
        this.renderDjs(remainingSeconds);
      }, 1000);
    },
    getGameInfoPostData(gameCode) {
      const data = {};
      data.game_code = gameCode;
      data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      data.uid = window.sessionStorage.getItem("login").split("&")[1];
      return data;
    },
    updateGameInfoStorage(gameInfo) {
      const waitOpenIssue = gameInfo.wait_open_issue || gameInfo.nextQihao || "";
      window.sessionStorage.setItem("code", gameInfo.code);
      window.sessionStorage.setItem("qiNum", waitOpenIssue);
      window.sessionStorage.setItem("isClose", gameInfo.isClose);
      window.sessionStorage.setItem("gameName", gameInfo.gameName);
      window.sessionStorage.setItem("gameType", gameInfo.game_type || "five_ball");
    },
    updateHeaderGameInfo(gameInfo) {
      const waitOpenIssue = gameInfo.wait_open_issue || gameInfo.nextQihao || "";
      this.gameTips = gameInfo.remark;
      this.ys = gameInfo.sold;
      this.sy = gameInfo.stock;
      this.gameName = gameInfo.gameName;
      this.qh = waitOpenIssue;
      this.syq = gameInfo.openQihao;
      this.website = gameInfo.website;
      this.dxds = gameInfo.dxds;
      this.boorList = [];
      if (gameInfo.openCode) {
        gameInfo.openCode.split(",").forEach(item => {
          let obj = {};
          obj.num = item;
          this.boorList.push(obj);
        });
      }
    },
    updateGameStatus(gameInfo, emitStatus) {
      if (gameInfo.isClose == 0) {
        this.fengpan = "封盘";
        this.startDjs(gameInfo.closeTime);
        if (emitStatus) {
          this.$emit("djsFp", "封盘");
        }
      } else {
        this.fengpan = "开奖";
        this.showDjsLoading();
        if (emitStatus) {
          this.$emit("djsFp", "开奖");
        }
      }
    },
    scheduleGameInfoRefresh(gameInfo) {
      clearInterval(this.parTimmer);
      const intervalTime = gameInfo && gameInfo.isClose == 0 ? 60000 : 5000;
      const data = this.getGameInfoPostData(this.current_select.code);
      this.parTimmer = setInterval(() => {
        this.getGameDataInterval(data);
      }, intervalTime);
    },
    applyGameInfo(gameInfo, options) {
      const opts = options || {};
      const prevIsClose = opts.prevIsClose !== undefined ? opts.prevIsClose : window.sessionStorage.getItem("isClose");
      const isCloseChanged = opts.force || String(prevIsClose) != String(gameInfo.isClose);

      this.updateHeaderGameInfo(gameInfo);
      this.updateGameStatus(gameInfo, opts.force || isCloseChanged);

      if (opts.force || isCloseChanged) {
        this.updateGameInfoStorage(gameInfo);
        this.updateGameNav(gameInfo);
        this.updateGameNumber(gameInfo);
        this.$event.$emit("gameInfoChanged", {
          gameCode: gameInfo.code,
          issue: gameInfo.wait_open_issue || gameInfo.nextQihao || ""
        });
      }

      this.scheduleGameInfoRefresh(gameInfo);
      return isCloseChanged;
    },
    changeGame(data){
      this.current_select = data
      const post_data = {'game_code':data.code};
      post_data.access_token = window.sessionStorage.getItem("login").split("&")[0];
      post_data.uid = window.sessionStorage.getItem("login").split("&")[1];
      const _this = this;
      getData.postAxiosMethod("gameinfo", post_data, res => {
        const gameInfo = this.normalizeGameInfo(res.data.data);
        if (!gameInfo) {
          return;
        }
        this.applyGameInfo(gameInfo, { force: true });
        this.$event.$emit('updateUserInfo')

      })

    },
    timmer() {
      const isClose = window.sessionStorage.getItem("isClose");
      this.scheduleGameInfoRefresh({ isClose: isClose });
    },
    //按游戏状态刷新数据：未封盘60s校对一次，封盘后5s刷新一次
    getGameDataInterval(data){
      // this.timmer()
      const _this = this;
      getData.postAxiosMethod("gameinfo", data, res => {
        if (data.game_code && _this.current_select.code && data.game_code != _this.current_select.code) {
          return;
        }
        const gameInfo = this.normalizeGameInfo(res.data.data);
        if (!gameInfo) {
          return;
        }
        const prevIsClose = window.sessionStorage.getItem("isClose");
        const isCloseChanged = _this.applyGameInfo(gameInfo, { prevIsClose: prevIsClose });
        if (!isCloseChanged) {
          return;
        }

        if(gameInfo.openQihao == ((gameInfo.wait_open_issue * 1) -1)){
          this.$event.$emit('updateUserInfo')
        }else{
          if(gameInfo.wait_open_issue.substr(gameInfo.wait_open_issue.length -4 ,3) == '001'){
            if(gameInfo.openQihao.substr(gameInfo.openQihao.length -4 ,3) == '288'){
              this.$event.$emit('updateUserInfo')
            }
          }
        }


        _this.$event.$emit('updateIssueList')

      });
    },
    getGameData(data) {
      // this.timmer();
      const _this = this;
      if(_this.current_select.code){
        _this.changeGame(_this.current_select)
      }else{
        getData.postAxiosMethod("gamelist", data, res => {
        const game_list = res.data.data

        _this.menuList = game_list;// [{ menu: res.data.data[0].gameName}];
        _this.changeGame(game_list[0])
        return


      });
      }

    }
  }
};
</script>
<style >
.top_bar .logo {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0;
  width: auto;
  height: auto;
}
.top_bar .logo .logo-title{
  position: absolute;
  left: 85px;
  top: 5px;
  font-size: 20px;
}
.top_bar #noticeLink {
  margin-left: 325px;
}
.navBtn {
  cursor: default;
}
.game_info_wrap h4 .time {
  width: auto;
  min-width: 180px;
  white-space: nowrap;
}
</style>>
